import { usePunditUserContext } from "@circle-react/contexts";

export const useEventsFeatureFlags = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return {
    hasSplitRecurringEventsEnabled:
      !!currentCommunitySettings?.split_recurring_events_enabled,
  };
};
